import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {PitActivityVersion} from "../../pit-activities/domain/pit-activity-version";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {fromPromise} from "rxjs/internal-compatibility";
import {BdpkConfigService} from "../../bdpk-common/services/bdpk-config.service";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {HttpHeaders} from "@angular/common/http";

/**
 * WARNING: Этот сервис нигде кроме dashboard не участвует, поэтому не provided в модуле!
 * Только в {@link PitDashboardFilesComponent}
 */
@Injectable()
export class PitDashboardService {

  constructor(private _configService: BdpkConfigService,
              private _mapper: DxObjectMapper,
              private _http: DxHttpDispatcher) {}


  public fetchActivityLastVersion(activityId: number): Observable<PitActivityVersion> {
    const promise = new Promise<PitActivityVersion>((resolve, reject) => {
      const path = this._configService.pitBackendActivitiesEndPoint + '/activities/' + activityId + '/last-version';
      this._http
        .get(path)
        .subscribe(response => {
          resolve(this._mapper.deserialize(response.body, PitActivityVersion));
        }, errorResponse => {
          reject(DxHttpDispatcher.handleHttpError(errorResponse));
        });
    });
    return fromPromise<PitActivityVersion>(promise);
  }

  public updateActivityVersion(data: PitActivityVersion): Observable<any> {
    const promise = new Promise<any>((resolve, reject) => {
      let path = this._configService.pitBackendActivitiesEndPoint + '/activities';
      path += '/'+ data.activity.id.toString();
      path += '/versions/' + data.id.toString();
      const activityVersion = this._mapper.serialize(data, PitActivityVersion);
      console.log(activityVersion);
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json;charset=utf-8')
        .set('Custom-Header', 'api-version=1')
        .set('Accept','application/json');
      this._http
        .put(path, activityVersion, {headers: headers, observe: 'response', withCredentials: true})
        .subscribe(response => {
            resolve(response)
          },
          errorResponse => {
            reject(DxHttpDispatcher.handleHttpError(errorResponse));
          });
    });
    return fromPromise(promise);
  }

}
